module.exports = __webpack_public_path__ + "img/city-3.e0d21964.png";